import Container from '@/components/@base/container';
import whiteCancelPayment from '@/assets/logos/white-cancel-payment.svg';
import darkCancelPayment from '@/assets/logos/dark-cancel-payment.svg';
import { Text } from '@/components/@base/typography';
import localization from '@/constant/localization';
import { SIZE_ENUM } from '@/components/@base/@types';
import useCommonModalStore from '@/store/common-modal-store';
import FontIcon from '@/components/@base/font-icon';
import Button from '@/components/@base/button';

const CancelPayment = () => {
  const {setShow} = useCommonModalStore()
  const handleRedirect = () => {
   localStorage.getItem('merchantRedirectURL') ? location.replace(localStorage.getItem('merchantRedirectURL')!) : history.back()
  }
  return <Container center className='flex-col p-4 pt-2'>
    <FontIcon icon="icon-cross" className='text-3xl text-red bg-red-50 rounded-full h-[56px] w-[56px] flex items-center justify-center mb-6'/>
    <Text semiBold className='text-grayLight-1000 dark:text-grayLight-0 mb-2 text-xl'>{localization.cancelPayment}</Text>
    <Text medium size={SIZE_ENUM.SM} className='text-grayLight-850 dark:text-[#CCCCD1] mb-8'>{localization.doYouWantCancelPayment}</Text>
    <Button
      className='w-full text-md rounded-full whitespace-nowrap px-8 text-danger-450 dark:text-red-300 dark:bg-red-900 bg-red-50 hover:!bg-danger-450/20'
      style={{height: '52px'}}
      size={SIZE_ENUM.XL}
      onClick={handleRedirect}
      id='upg-choose-asset-selection'
    >
      {localization.cancelPaymentAndExit}
    </Button>
    <Button
      className='w-full mt-3 text-md rounded-full whitespace-nowrap px-8 text-grayLight-1000 bg-grayLight-100 dark:bg-grayDark-750 hover:!bg-grayLight-1000/10 dark:text-white cursor-pointe'
      style={{height: '52px'}}
      size={SIZE_ENUM.XL}
      id='upg-continue-perchese-whithout-asset-selection'
      onClick={()=> setShow(false)}
    >
      {localization.continuePayment}
    </Button>
  </Container>
}

export default CancelPayment;